export default __webpack_public_path__ + "static/growth-4344caf19c99894666102509f4aeed61.gif";